<template>
  <footer class="footer">
    <div class="content has-text-centered has-text-dark">
      <p>
        <strong>Beerview</strong> {{ t('footer.byTeam') }}
        {{ t('footer.builtWith') }} <i class="fas fa-beer"></i>, Vue.js
        {{ t('footer.and') }} PHP.
      </p>
      <p class="is-size-7">
        &copy; {{ currentYear }} Beerview. {{ t('footer.allRights') }}
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const currentYear = computed(() => new Date().getFullYear())
</script>
